export default "__VITE_ASSET__d93f052c__"